import { useTheme } from '@mui/material/styles';

import { PaperProps } from '../../../library/Paper';
import { renderHTMLString } from '../../../../../../helpers';
import InfoWidgetItemLayout, {
  InfoWidgetItemLayoutProps,
} from '../InfoWidgetItemLayout';
import Typography from '../../../library/Typography';

import { StyledPaper, StyledTitle } from './styles';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';

export interface InfoWidgetItemProps
  extends Omit<PaperProps, 'title'>,
    InfoWidgetItemLayoutProps {}

export default function InfoWidgetItemWithPaper(props: InfoWidgetItemProps) {
  const { icon, title, description, closeIcon, children, ...paperProps } =
    props;
  const theme = useTheme();
  const { location } = useRootSelector(selectPageConfig);

  return (
    <StyledPaper
      backgroundRGBColor={theme.palette.neutral.RGB200}
      opacity={0.3}
      paddingVariant="small"
      {...paperProps}
    >
      <InfoWidgetItemLayout
        icon={icon}
        closeIcon={closeIcon}
        title={
          <StyledTitle
            variant="h5"
            paletteColorName="brandSecondary"
            component="div"
          >
            {title}
          </StyledTitle>
        }
        description={
          description && (
            <Typography
              variant="smallText"
              neutralColorIndex={600}
              component="div"
            >
              {typeof description === 'string'
                ? renderHTMLString(description, location)
                : description}
            </Typography>
          )
        }
      >
        {children}
      </InfoWidgetItemLayout>
    </StyledPaper>
  );
}
